<template>
	<unauth-layout>
		<template slot="page-content">

			<h2 id="moto">
				a free
				<span style="border-bottom:2px dashed #ccc;">user-owned</span> storage solution for (web)apps
			</h2>

			<vue-markdown class='markdown' :source="forwhoMD" v-once>
			</vue-markdown>

			<div id="toc" v-html="tocSource"></div>

			<vue-markdown class='markdown readme' :source="mainMD" :watches="['show','html','breaks','linkify','emoji','typographer','toc']" :show="show" :html="html" :breaks="breaks" :linkify="linkify" :emoji="emoji" :typographer="typographer" :toc="toc" v-on:rendered="allRight" v-on:toc-rendered="tocAllRight" toc-id="toc" :toc-anchor-link="false" toc-anchor-link-symbol="#">
			</vue-markdown>

			<div id="footer-firstpage"></div>

		</template>
	</unauth-layout>
</template>

<script>
const logger = require("@/utils/logger");
import router from "../router";
import VueMarkdown from "vue-markdown";

const forwhoMD = require("@/assets/markdown/firstpage-forwho.md");
const mainMD = require("@/assets/markdown/firstpage-main.md");

export default {
  props: ["error"],
  data() {
    return {
      origin: window.location.origin,
      show: true,
      html: true,
      breaks: true,
      linkify: false,
      emoji: true,
      typographer: true,
      toc: true,
      tocSource: "",
      tocAnchorLink: false,
      modalTitle: "",
      modalContent: "",
      forwhoMD: forwhoMD,
      mainMD: mainMD
    };
  },
  components: {
    VueMarkdown
  },
  methods: {
    allRight: function(htmlStr) {
      //logger.log("markdown is parsed !");
      //console.log(htmlStr)
    },
    tocAllRight: function(tocHtmlStr) {
      //this.tocSource = tocHtmlStr;
    }
  },
  mounted() {
    window._onestore_mode = "plain";

    $("table").each(function(i, e) {
      $(e).stacktable();
    });

    $("img#sketch")[0].src = require("@/assets/images/sketch4.jpg");
  },
  updated: function() {
    this.$nextTick(function() {
      logger.log("Rendered in " + (new Date().getTime() - window.t0));
    });
  }
};
</script>

<style>
table.large-only {
  display: table;
}
table.small-only {
  display: none;
}

@media (max-width: 700px) {
  table.large-only {
    display: none;
  }
  table.small-only {
    display: table;
  }
}

#moto {
  margin: 30px 0 40px 0;
  font-size: 1.7em;
  font-weight: bold;
  text-align: center;
}
.markdown {
  margin-top: 0;
}
.sketch {
  width: 500px;
  max-width: 100%;
  margin: 40px auto;
  display: block;
  border: 1px solid #ddd;
}
#toc {
  /*display: none;*/
  margin-top: 40px;
}
.markdown {
  clear: both;
}
#toc ul {
  padding: 0;
  margin-left: 20px;
}
#toc ul li {
  list-style-type: circle;
}
#toc ul li ul {
  /*display: none; /* only show first level */
}
.readme h2 {
  margin-top: 30px;
  font-size: 1.5em;
  font-weight: bold;
}
.readme h3 {
  margin-top: 20px;
  font-size: 1.2em;
}
.readme table,
.readme table td,
.readme table th {
  border: 1px solid #ccc;
  padding: 10px;
}
.readme p {
  margin-top: 20px;
}
table {
  overflow: auto;
}
#footer-firstpage {
  border-color: #ccc;
  border-bottom: 1px dashed #ccc;
  margin: 40px 0 40px 0;
}
.markdown a,
#toc {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/FirstPage.vue